import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class FarmModel extends BaseModel {

    constructor() {
        super({
                name: "farm",
                tableName: 'farm',
                label: "Quản Lý Trang trại",
                display_key: 'name',
                default_order: { key: 'updated_at', direction: 'asc' }
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    class: "center",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                code: { 
                    name: 'code',
                    type: "String",
                    class: "center",
                    label: 'Mã trang trại',
                    filter: {type: 'input', match: 'contains'},
                },
                name_company: {
                    name: 'name_company',
                    type: "String",
                    class: "center",
                    label: 'Tên công ty',
                    sortable: false,
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                },
                name: { 
                    name: 'name',
                    type: "String",
                    class: "center",
                    label: 'Tên trang trại',
                    sortable: false,
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                },
                address : { 
                    name: 'address',
                    type: "String",
                    class: "center",
                    label: 'Địa chỉ',
                    filter: {type: 'input', match: 'contains'},
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                company_id: {
                    name: 'company_id',
                    type: "Uuid",
                    label: 'ID công ty',
                    display: false
                },
                has_units: {
                    refs: 'farm_has_units { unit { id code name active unit_id obj_boxes { kind_in_box(where: { exported: {_eq: false}, number: {_gt: 0}}) { id number exported } active total kind { type_id type { id name } } } } }',
                    display: false
                },
                farm_has_kind_type: {
                    refs: 'farm_has_kind_type {id type {id name}}',
                    display: false
                },
                farm_kind_productivity: {
                    refs: 'farm_kind_productivity {id productivity kind_type_id}',
                    display: false
                },
                units: {
                    name: "units",
                    label: "Số lượng unit",
                    type: "CustomUrl",
                    class: "center",
                    computed: (data) => {
                        data.units = 0;
                    },
                    display: false
                },
                unit_active: {
                    name: "unit_active",
                    label: "SL unit active",
                    type: "Number",
                    class: "center",
                    computed: (data) => {
                        data.units = 0;
                    }
                },
                box: {
                    name: "box",
                    label: "SL hộp active",
                    type: "Number",
                    class: "center",
                    computed: (data) => {
                        data.units = 0;
                    }
                },
                type: {
                    name: "type",
                    label: "Chủng loại",
                    type: "CustomUrl",
                    class: "center",
                    computed: (data) => {
                        data.units = 0;
                    }
                },
                active: {
                    name: "active",
                    type: "Selection", 
                    custom: 'SelectionText',
                    label: "Trạng thái",
                    class: "center",
                    options: [
                        {value : true , label: "Hoạt động"},
                        {value : false , label : "Không hoạt động"}
                    ],
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
                },
                scale: {
                    name: 'scale',
                    display: false
                },
                franchise: {
                    name: 'franchise',
                    type: "Selection",
                    custom: 'SelectionText',
                    class: "center",
                    label: 'Franchise',
                    options: [
                        {value : true , label: "Thuộc công ty"},
                        {value : false , label : "Không thuộc công ty"}
                    ],
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
                },
                street: {
                    name: 'street',
                    display: false
                },
                ward: {
                    refs: 'ward {id name}',
                    display: false
                },
                district: {
                    refs: 'district {id name}',
                    display: false
                },
                state: {
                    refs: 'state {id name}',
                    display: false
                },
                name_direction: {
                    name: 'name_direction',
                    display: false
                },
                phone_direction: {
                    name: 'phone_direction',
                    display: false
                },
                email_direction: {
                    name: 'email_direction',
                    display: false
                },
                updated_at: {
                    name: 'updated_at',
                    type: "Datetime",
                    class: "center",
                    label: 'Ngày cập nhật',
                    filter: {
                        type: "DateRange", match: "contrains",
                    },
                },
                banner_link: {
                    name: 'banner_link',
                    display: false
                },

            },
            )
    }

}